/* eslint-disable max-len */
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import { BaseCard as Card } from './baseCard';

export const Card05 = () => (
  <VisibilitySensor delayedCall partialVisibility offset={{ top: 95 }}>
    {({ isVisible }) => (
      <Card
        bio="Chief of Mission at IOM - UN Migration."
        image={
          <StaticImage
            alt="Safdar Ameen"
            className="w-16 h-16"
            src="./card-05.jpg"
          />
        }
        isVisible={isVisible}
        name="Safdar Ameen"
        text="Mr. Raja is one of best QC OM and very active and very coup able men as long as i know him and were working to gather."
      />
    )}
  </VisibilitySensor>
);
